import { Component, input, output } from '@angular/core';
import { AddCondition, Command, Condition } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-conditions-block',
  templateUrl: 'conditions-block.component.html',
  styleUrls: ['./conditions-block.component.scss']
})
export class ConditionsBlockComponent {
  isEditing = input<boolean>();
  previousQuestions = input<Question[]>([]);
  conditions = input<(Condition | Command)[]>([]);

  addMore = output<void>();
  cancel = output<void>();
  remove = output<number>();
  save = output<AddCondition>();
}
